import { render, staticRenderFns } from "./getPlate.vue?vue&type=template&id=8307cac6"
import script from "./getPlate.vue?vue&type=script&lang=js"
export * from "./getPlate.vue?vue&type=script&lang=js"
import style0 from "./getPlate.vue?vue&type=style&index=0&id=8307cac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports